export const IMAGE_UPLOAD = "IMAGE_UPLOAD";
export const IMAGE_RELOAD = "IMAGE_RELOAD";
export const IMAGE_DELETED = "IMAGE_DELETED";
export const IMAGE_CLEAN = "IMAGE_CLEAN";
export const IMAGE_CONNECT = "IMAGE_CONNECT";
export const IMAGE_DISCONNECT = "IMAGE_DISCONNECT";
export const IMAGE_GET = "IMAGE_GET";
export const IMAGE_RIGHTS_UPDATED = "IMAGE_RIGHTS_UPDATED";
export const IMAGE_ACTIVE = "IMAGE_ACTIVE";
export const IMAGE_INACTIVE = "IMAGE_INACTIVE";
